
import { Component, Prop, Vue } from 'vue-property-decorator'
import IconInShape from '~/components/common/icon/IconInShape.vue'
import { isMobile } from '~/lib/utils/utils'

const iconColor = (color: string) => {
  return {
    iconColor: color
  }
}

const shapeColor = (color: string) => ({ shapeColor: color })

@Component({
  name: 'CardRoundCtrl',
  components: {
    IconInShape
  }
})
export default class CardRoundCtrl extends Vue {
  @Prop({ type: Object, required: true }) shapeColor!: Utils.ElementStates
  @Prop({ type: Object, required: true }) iconColor!: Utils.ElementStates
  @Prop({ type: String, required: true }) iconName!: boolean
  @Prop({ type: String, default: '12px' }) iconSize!: string
  @Prop({ type: String, default: '25px' }) shapeSize!: string
  @Prop({ type: Boolean, default: false }) isActive!: boolean

  isHovered = false
  isMobile = isMobile()

  get styles() {
    const iconStyles = this.isActive
      ? iconColor(this.iconColor.active)
      : this.isHovered && !this.isMobile
        ? iconColor(this.iconColor.hover)
        : iconColor(this.iconColor.regular)

    const shapeStyles = this.isActive
      ? shapeColor(this.shapeColor.active)
      : this.isHovered && !this.isMobile
        ? shapeColor(this.shapeColor.hover)
        : shapeColor(this.shapeColor.regular)

    return { ...iconStyles, ...shapeStyles }
  }

  private mouseenter() {
    this.isHovered = true
  }

  private mouseleave() {
    this.isHovered = false
  }
}
